import { useState, useEffect, useCallback } from 'react'
import { cronLogsService } from '../services/cronLogsService'
import type { CronEventLog, CronEventFilters, CronEventType, CronJobName } from '../types'

export function useCronEvents(executionId: number) {
  const [data, setData] = useState<CronEventLog[]>([])
  const [total, setTotal] = useState(0)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [filters, setFilters] = useState<CronEventFilters>({
    page: 1,
    limit: 50,
  })

  const fetchData = useCallback(async () => {
    setIsLoading(true)
    setError(null)
    try {
      const response = await cronLogsService.getEvents(executionId, filters)
      setData(response.data)
      setTotal(response.total_items)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar eventos')
    } finally {
      setIsLoading(false)
    }
  }, [executionId, filters])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const setPage = (page: number) => setFilters((prev) => ({ ...prev, page }))

  const setEventTypeFilter = (event_type: CronEventType | undefined) =>
    setFilters((prev) => ({ ...prev, event_type, page: 1 }))

  const setJobNameFilter = (job_name: CronJobName | undefined) =>
    setFilters((prev) => ({ ...prev, job_name, page: 1 }))

  const clearFilters = () => setFilters({ page: 1, limit: filters.limit })

  return {
    data,
    total,
    isLoading,
    error,
    filters,
    setPage,
    setEventTypeFilter,
    setJobNameFilter,
    clearFilters,
  }
}
